import MainLayout from '@/components/layout/MainLayout.vue';
import { required, email, sameAs, minLength, maxLength, numeric, helpers } from 'vuelidate/lib/validators';
import $ from "jquery";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";

const phoneFormat = helpers.regex('phoneFormat', /^(\+?95|0)?(9\d{7,9})$/);

export default {
    name: "signupStudent",

    components: {
        MainLayout,
        Loading,
    },

    data() {
        return {
            signupForm: {
                profile: '',
                name: '',
                phone_number_1: '',
                email_1: '',
                password: '',
                confirm_password: ''
            },
            profile: '',
            errorArr: [],
            submitted: false,
            isLoading: false,
            disabled: false,
        }
    },

    props: ['data'],

    validations: {
        signupForm: {
            name: {
                required,
                maxLength: maxLength(100)
            },
            phone_number_1: {
                required,
                maxLength: maxLength(20),
                numeric,
                phoneFormat
            },
            email_1: {
                required,
                email
            },
            password: {
                required,
                minLength: minLength(8),
                maxLength: maxLength(12)
            },
            confirm_password: {
                required,
                sameAsPassword: sameAs("password")
            }
        },
    },

    methods: {
        onProfileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return null;
            this.signupForm.profile = e.target.files[0];
            let reader = new FileReader();
            reader.onload = (e) => {
                this.profile = e.target.result;
            };
            reader.readAsDataURL(files[0]);
        },

        submit() {
            this.submitted = true;
            if (this.$v.signupForm.$invalid) {
                return;
            }
            this.signUp()
        },
        
        signUp() {
            this.disabled = true;
            this.isLoading = true;
            this.signupForm.profile = this.profile;
            axios.post("/register/student", this.signupForm, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    const phone_number = response.data.phone_number_1;
                    this.$notification.success("Registration လုပ်ဆောင်ချက်အောင်မြင်ပါသည်။ Register လုပ်ထားသော Password ဖြင့် Login ဝင်ပေးပါ။", {
                        timer: 3,
                        position: 'topCenter'
                    });
                    localStorage.setItem('phoneNo', phone_number);
                    this.$router.push({
                        name: "login"
                    });
                })
                .catch((error) => {
                    this.isLoading = false;
                    this.disabled = false;
                    this.errorArr = error.response.data.errors;
                    console.log("signup error", error);
                    this.loading = false;
                });
        }
    },

    mounted() {
        $("#phone_number_1").on("keypress keyup blur", function (event) {
            $(this).val($(this).val().replace(/[^\d].+/, ""));
            if ((event.which < 48 || event.which > 57)) {
                event.preventDefault();
            }
        });
    },
};
